import { render, staticRenderFns } from "./ListContacts.vue?vue&type=template&id=1a8ebfaf&scoped=true"
import script from "./ListContacts.vue?vue&type=script&lang=js"
export * from "./ListContacts.vue?vue&type=script&lang=js"
import style0 from "./ListContacts.vue?vue&type=style&index=0&id=1a8ebfaf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8ebfaf",
  null
  
)

export default component.exports